module.exports = __webpack_public_path__ + "img/temp-aircon-off.cd59351c.svg";